import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

const BASE_Z_INDEX = 50

type OpenOptions = {
  closeOthers?: boolean
  state?: unknown
}

export interface DialogState<S = any> {
  activeDialogs: string[]
  openDialog: (name: string | string[], opts?: OpenOptions) => void
  closeDialog: (name: string) => void
  closeAllDialogs: () => void
  getDepth: (name: string) => number
  state?: S | null
}

export const useDialogStore = create<DialogState>()(
  devtools(
    (set, get) => ({
      activeDialogs: [],
      openDialog: (name, opts) => {
        if (opts?.closeOthers) {
          set({ activeDialogs: [...new Set(Array.isArray(name) ? name : [name])] })
        } else {
          if (Array.isArray(name)) {
            set((state) => ({
              activeDialogs: [...state.activeDialogs.filter((n) => !name.includes(n)), ...name],
            }))
          } else {
            set((state) => ({
              activeDialogs: [...new Set([...state.activeDialogs.filter((n) => n !== name), name])],
            }))
          }
        }
        set({ state: opts?.state })
      },
      closeDialog: (name) =>
        set((state) => {
          if (!state.activeDialogs.includes(name)) {
            // Do nothing
            return {}
          }

          const newDialogs = new Set(state.activeDialogs)
          ;(Array.isArray(name) ? name : [name]).forEach((dialogName) => {
            newDialogs.delete(dialogName)
          })
          return { activeDialogs: [...newDialogs] }
        }),
      closeAllDialogs: () => {
        set({ activeDialogs: [] })
      },
      getDepth: (name) => BASE_Z_INDEX + get().activeDialogs.indexOf(name),
    }),
    {
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
